import { UserModel } from '@/components/task-forms/models';

/**
 * * Модель с информацие о проекте
 */
export class ProjectModel {
  /**ID проекта */
  Id!: number | string;
  /**Название */
  Name!: string;
  /**Изображение проекта */
  ImageUrl!: string;
  /**Цвет проекта */
  PreviewColor!: string;
  /**Список администраторов */
  Admins?: UserModel[];
  /**Активна интеграция week */
  WeekEnable?: boolean;

  constructor(obj?: Partial<ProjectModel>) {
    Object.assign(this, obj);
  }
}
